module.exports = __webpack_public_path__ + "img/add-image-1.e8143f23.png";